<template>
    <footer class="flex_c_center">
        <a href="https://beian.miit.gov.cn/">{{footer}}</a>
    </footer>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'myFooter',
    computed:{
        ...mapState({
            footer: state=>state.config.footer
        })
    },
}
</script>
<style lang="less" scoped>
footer{
  padding: 60px 0;
  font-size: 16px;
  line-height: 22px;
  color: #958F8F;
  margin-top: 60px;
  background: #E6E6E6;
}
</style>